import { createApiService, ConfigHelper, Api } from 'relapp-api';

export default {
    ...createApiService('servers', 'server'),

    /**
     * Get the server sso url.
     *
     * @param {number} serverId
     *
     * @return {Promise}
     */
    createSSOLink(serverId) {
        const url = ConfigHelper.apiUrl('server.sso', [
            {
                key: '{server}',
                value: serverId
            }
        ]);

        return Api.get(url);
    }
};
